import { Component, Input, OnChanges, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";

export interface PillStatusConfig {
  id: number;
  status: string;
  textColor: string;
  color: string;
  border: string;
  dashed?: boolean;
}

@Component({
    selector: "app-status-pill",
    imports: [CommonModule],
    templateUrl: "./status-pill.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./status-pill.component.css"]
})
export class StatusPillComponent implements OnInit, OnChanges {
  @Input() statusId: number;
  @Input() statusConfig: PillStatusConfig[] = [];

  color: string;
  status: string;
  textColor: string;
  border: string;
  dashed: boolean;

  ngOnInit(): void {
    this.update();
  }

  ngOnChanges(): void {
    this.update();
  }

  private update(): void {
    const entry = this.statusConfig?.find((s) => s.id === this.statusId);
    this.status = entry?.status ?? "";
    this.color = entry?.color ?? "";
    this.textColor = entry?.textColor ?? "";
    this.border = entry?.border ?? "";
    this.dashed = entry?.dashed ?? false;
  }
}
